export class DbEntity {
  id?: number | null;
}
